module.exports = __webpack_public_path__ + "img/77.4.NH3-N.d9eafafb.png";